import React from "react";
import "./style.css";

export default function SessionLoadingGraphic() {
  return (
    <div className="pi-session-loading" aria-hidden="true">
      <div className="pi-session-loading__glow" />
      <svg
        className="pi-session-loading__svg"
        viewBox="0 0 280 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label=""
      >
        <defs>
          <linearGradient id="pi-loading-car-body" x1="0" y1="0" x2="1" y2="1">
            <stop stopColor="#2563eb" />
            <stop offset="1" stopColor="#1d4ed8" />
          </linearGradient>
          <linearGradient id="pi-loading-car-glass" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#dbeafe" />
            <stop offset="1" stopColor="#93c5fd" />
          </linearGradient>
          <linearGradient id="pi-loading-road" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#e2e8f0" />
            <stop offset="1" stopColor="#cbd5e1" />
          </linearGradient>
        </defs>

        <rect
          className="pi-session-loading__road"
          x="0"
          y="88"
          width="280"
          height="32"
          rx="4"
          fill="url(#pi-loading-road)"
        />
        <line
          className="pi-session-loading__lane"
          x1="-20"
          y1="102"
          x2="300"
          y2="102"
          stroke="#94a3b8"
          strokeWidth="2"
          strokeDasharray="14 12"
          strokeLinecap="round"
        />

        <g className="pi-session-loading__motion">
          <path d="M18 72h24" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" opacity="0.5" />
          <path d="M8 78h18" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" opacity="0.35" />
          <path d="M24 66h16" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" opacity="0.25" />
        </g>

        <g className="pi-session-loading__car">
          <path
            d="M34 78h52c2.2 0 4 1.8 4 4v6c0 2.2-1.8 4-4 4H34c-2.2 0-4-1.8-4-4v-6c0-2.2 1.8-4 4-4z"
            fill="url(#pi-loading-car-body)"
          />
          <path
            d="M38 62h28l8 16H34l4-16z"
            fill="url(#pi-loading-car-body)"
          />
          <path
            d="M42 64h20l5 12H40l2-12z"
            fill="url(#pi-loading-car-glass)"
          />
          <path
            d="M78 66h8l4 12h-8l-4-12z"
            fill="url(#pi-loading-car-glass)"
            opacity="0.85"
          />
          <circle cx="86" cy="74" r="2.5" fill="#fef08a" />
          <rect x="30" y="72" width="4" height="6" rx="1" fill="#ef4444" opacity="0.85" />

          <g className="pi-session-loading__wheel pi-session-loading__wheel--rear">
            <circle cx="44" cy="88" r="9" fill="#0f172a" />
            <circle cx="44" cy="88" r="5.5" fill="#334155" />
            <circle cx="44" cy="88" r="2" fill="#94a3b8" />
          </g>
          <g className="pi-session-loading__wheel pi-session-loading__wheel--front">
            <circle cx="74" cy="88" r="9" fill="#0f172a" />
            <circle cx="74" cy="88" r="5.5" fill="#334155" />
            <circle cx="74" cy="88" r="2" fill="#94a3b8" />
          </g>
        </g>
      </svg>
    </div>
  );
}
